<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addGoods" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table ref="list" border :data="tableData" style="width: 100%"  @row-click="rowClick">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{row}">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event,row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal='listTotal'
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType='true'
          />
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="BatchNo" label="批次" />
      <el-table-column prop="UnitName" label="单位">
          <template slot-scope="{row}">
              <el-input v-model="row.UnitName" v-if="row.MultiUnit"></el-input>
              <span v-else>{{row.UnitName}}</span>
          </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="盘点数量">
        <template slot-scope="{ row }">
          <el-input v-model="row.Quantity" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(scope.row,scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click="del(scope.row,scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
import accountSelect from "@/components/sales/business/select";
export default {
  props: {
    info: {},
  },
  components: {
    goodsDialog,
    accountSelect
  },
  data() {
    return {
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      DAccount: [],
      tableData: [],
      tableDel: [],
      sApi: require("@/api/sale/sales").default,
      api: require("@/api/stock/inventory").default,
      account_api: require("@/api/goods/goods").default,
      initDAccount:[],
      initTotal:0,
    };
  },
    mounted() {
    this.account_api.list({ Status: 1,pageIndex:1,pageSize:7 }).then((res) => {
      if (res.Code == 0) this.DAccount = res.Data,this.initDAccount=res.Data,this.initTotal=res.Count;
    });
  },
  methods: {
    resetFun(){
      this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage(val, row){
      let GoodsName = row.GoodsName;
      this.pageParams.pageIndex=val
          this.account_api.list({ Status: 1,pageIndex: val,pageSize:7, GoodsName }).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    inputText(text, row){
       row.GoodsName = text;
       this.account_api.list({ Status: 1,pageIndex:1,pageSize:7 ,GoodsName:text}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    rowClick(row) {
      var index = this.$refs.list.data.indexOf(row);
      if (index + 1 == this.$refs.list.data.length) {
        // 
        this.addGoods();
      }
    },
    getData() {
      if(this.info.DocId != 0 && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          if(item.T) {
            this.tableDel.push(item)
          }
        })
      }
      this.tableData = []
      this.sApi.getGoodsList(this.info.OrderId).then((res) => {
        res.Data.forEach(e => {
          this.tableData.push({
            T: 0,
            DocGoodsId: 0,
            DocId: this.info.DocId,
            BarCode: e.BarCode || "",
            GoodsId: e.GoodsId || 0,
            GoodsName: e.GoodsName || "",
            Model: e.Model || "",
            UnitId: e.UnitId || 0,
            UnitName: e.UnitName || "",
            MultiUnit: e.MultiUnit || false,
            Quantity: e.Quantity || 0,
            BatchNo: e.BatchNo || "",
            Offer: e.Offer || 0,
            Remark: e.Remark || "",
            ReferenceCost: e.ReferenceCost || 0,
            InventoryQuantity: e.InventoryQuantity || 0,
            DiffQuantity: e.DiffQuantity || 0,
            Thumbnail: e.Thumbnail || "",
            AddTime: e.AddTime || "",
          })
        });
      });
    },
    del(row,index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(!row.T&&row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          this.tableData.splice(index,1)
        })
    },
    copy(row,index) {
      this.tableData.splice(index+1,0,{
        ...row,
        T: 0,
        DocGoodsId: 0
      })
    },
        onSelect(e, row) {
          
              row.T=0,
              row.DocGoodsId= 0,
              row.DocId= this.info.DocId,
              row.BarCode= e.BarCode || "",
              row.GoodsId= e.GoodsId || 0,
              row.GoodsName= e.GoodsName || "",
              row.Model= e.Model || "",
              row.UnitId= e.MainUnitId || 0,
              row.UnitName= e.MainUnitName || "",
              row.MultiUnit= e.MultiUnit || false,
              row.Quantity= e.Quantity || 0,
              row.BatchNo= e.BatchNo || "",
              row.Offer= e.Offer || 0,
              row.ReferenceCost= e.ReferenceCost || 0,
              row.InventoryQuantity= e.InventoryQuantity || 0,
              row.DiffQuantity= e.DiffQuantity || 0,
              row.Remark= e.Remark || "",
              row.Thumbnail= e.Thumbnail || "",
              row.AddTime= this.info.DocDate || ""
    },
    addGoods(e) {
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1 });
      // });
         let goods = {
            T: 0,
            DocGoodsId: 0,
            DocId:0,
            BarCode:"",
            GoodsId:0,
            GoodsName:"",
            Model:"",
            UnitId: 0,
            UnitName:"",
            MultiUnit:false,
            Quantity:  0,
            BatchNo:"",
            Offer:0,
            Remark: "",
            ReferenceCost: 0,
            InventoryQuantity:  0,
            DiffQuantity: 0,
            Thumbnail:"",
            AddTime: "",
        }
        this.tableData.push(goods)
    },
    setGoods(e) {
      
      this.tableData.push({
        T: 0,
        DocGoodsId: 0,
        DocId: this.info.DocId,
        BarCode: e.BarCode || "",
        GoodsId: e.GoodsId || 0,
        GoodsName: e.GoodsName || "",
        Model: e.Model || "",
        UnitId: e.MainUnitId || 0,
        UnitName: e.MainUnitName || "",
        MultiUnit: e.MultiUnit || false,
        Quantity: e.Quantity || 0,
        BatchNo: e.BatchNo || "",
        Offer: e.Offer || 0,
        ReferenceCost: e.ReferenceCost || 0,
        InventoryQuantity: e.InventoryQuantity || 0,
        DiffQuantity: e.DiffQuantity || 0,
        Remark: e.Remark || "",
        Thumbnail: e.Thumbnail || "",
        AddTime: this.info.DocDate || "",
      })
    }
  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
</style>